export default __webpack_public_path__ + "static/media/Straight-Line-Logo-Blue.b35fc644.svg";